
const digest = '25cc8df2eb4246a04213bca8e926d77f0dadefc4d58c0a10cd8d9ee097f1f75e';
const classes = {"wrapper":"_wrapper_w051k_1","content":"_content_w051k_4","text":"_text_w051k_9","controls":"_controls_w051k_14"};
const css = `._wrapper_w051k_1 {
  font-family: Rubik, "sans-serif";
}
._wrapper_w051k_1 ._content_w051k_4 {
  background-color: #eaedf3;
  margin: -34px -24px 24px -24px;
  padding: 30px 24px;
}
._wrapper_w051k_1 ._content_w051k_4 ._text_w051k_9 {
  color: #000000;
  font-weight: 400;
  font-size: 18px;
}
._wrapper_w051k_1 ._controls_w051k_14 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  